import { AxiosError } from 'axios'
import { FORM_ERROR, SubmissionErrors } from 'final-form'

import { ErrorCode, ErrorResponse } from '@infura/packages.api'
import { SUPPORT_ARTICLES } from '@infura/packages.common/constants'
import { isAxiosError } from '@infura/packages.common/errors'

const SupportLink = () => (
  <a
    className='text-white underline'
    href={SUPPORT_ARTICLES.fraudCheckFailed}
    rel='noopener noreferrer'
    target='_blank'
  >
    read our support article.
  </a>
)

export default function handleSubmissionError(
  e: AxiosError<ErrorResponse> | Error,
  errorMessage?: string
): SubmissionErrors {
  if (isAxiosError(e)) {
    const {
      // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
      data: { error: { code = '', details = [], message = '' } = {} }
    } = e.response

    if (code === ErrorCode.VALIDATION) {
      return details.reduce(
        (final, curr) => ({
          ...final,
          [curr.target]: curr.message
        }),
        { [FORM_ERROR]: errorMessage || message }
      )
    } else {
      if (code === ErrorCode.INVALID_EMAIL) {
        return {
          [FORM_ERROR]: (
            <>
              <span>Email domain not supported. To learn more </span>
              <SupportLink />
            </>
          )
        }
      }

      return {
        [FORM_ERROR]: errorMessage || message
      }
    }
  } else {
    return { [FORM_ERROR]: errorMessage || typeof e === 'string' ? e : e.message }
  }
}
